import type { UserSummary } from '@blackblack/shared';
import { api } from '../../lib/api';
import { useInfinite } from '../../lib/query';
import { navigate, useParams } from '../../lib/router';
import { EmptyState, LoadMore, Skeleton, Tabs } from '../../components/ui/primitives';
import { Page, PageHeader } from '../../components/layout';
import { UserRow } from '../../components/UserRow';

export function FollowListPage() {
  const { username, kind } = useParams<{ username: string; kind: string }>();
  const type = kind === 'following' ? 'following' : 'followers';
  const list = useInfinite<UserSummary & { isFollowing: boolean }>(`follows:${type}:${username}`, (cursor) => api.page<UserSummary & { isFollowing: boolean }>(`/users/${encodeURIComponent(username)}/${type}`, { cursor }));
  return (
    <Page>
      <PageHeader title={`@${username}`} fallback={`/u/${username}`} />
      <Tabs
        tabs={[
          { id: 'following', label: 'Volgend' },
          { id: 'followers', label: 'Volgers' },
        ]}
        value={type}
        onChange={(t) => navigate(`/u/${username}/${t}`, { replace: true })}
        sticky
      />
      {list.initialLoading &&
        [0, 1, 2, 3].map((i) => (
          <div key={i} style={{ display: 'flex', gap: 12, padding: '10px 16px', alignItems: 'center' }}>
            <Skeleton w={48} h={48} r={24} />
            <Skeleton w={160} h={14} />
          </div>
        ))}
      {!list.initialLoading && list.items.length === 0 && <EmptyState icon="users" title={type === 'followers' ? 'Nog geen volgers' : 'Volgt nog niemand'} />}
      {list.items.map((u) => (
        <UserRow key={u.id} user={u} following={u.isFollowing} />
      ))}
      <LoadMore onVisible={list.loadMore} loading={list.loading} hasMore={list.hasMore} />
    </Page>
  );
}
